import { createContext, useContext } from 'react';
export const LoginAppearanceContext = createContext(null);
export const useLoginAppearance = () => useContext(LoginAppearanceContext);
